import { render, staticRenderFns } from "./BN.vue?vue&type=template&id=0dc8df7d&scoped=true&"
import script from "./BN.vue?vue&type=script&lang=js&"
export * from "./BN.vue?vue&type=script&lang=js&"
import style0 from "./BN.vue?vue&type=style&index=0&id=0dc8df7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc8df7d",
  null
  
)

export default component.exports